import { FormatDateIso } from "utils/dateUtils";
import CancelIcon from "@mui/icons-material/Cancel";
import { grey } from "@mui/material/colors";
import { IAccountReceivablesWithPayments } from "Dashboard/scenes/Partners/domain";
import { useAppDispatch } from "hooks/hooks";
import { setIndexesForPaymentDeletion, updateReceivedPayment, updateReceivedPaymentTemporarily } from "../accountReceivable.slice";
import InfoTooltip from "components/Popup/InfoTooltip";
import { IUpdateReceivedPaymentRequestParams } from "Dashboard/scenes/Partners/domain/IUpdateReceivedPaymentRequestParams";
import { debounce } from "lodash";
import { useMemo } from "react";
import { toast } from "react-toastify";
import NumberInput from "Dashboard/components/NumberInput";
import DatePicker from "react-datepicker";
import { selectState as selectStateAuth } from "authentication/main.slice";
import { hasFullAccessTo, hasWriteAccessTo } from "utils/authUtil";
import { PARTNER_MODULE_NAME } from "Dashboard/scenes/Partners/domain/PartnerModule";
import { useSelector } from "react-redux";
import { getVatRatePresentation } from "Dashboard/components/VatSelect";

interface IProps {
  accountIndex: number;
  item: IAccountReceivablesWithPayments;
}

export const RecievedPayments = ({ item, accountIndex }: IProps) => {
  const dispatch = useAppDispatch();
  const { user } = useSelector(selectStateAuth);

  const onChangeBasicField = (data: IUpdateReceivedPaymentRequestParams) => {
    dispatch(updateReceivedPaymentTemporarily(data));
    updateFieldWithDelay(data);
  };

  const updateFieldWithDelay = useMemo(
    () => debounce(async (data: IUpdateReceivedPaymentRequestParams) => {
      try {
        await dispatch(updateReceivedPayment(data)).unwrap();
        toast.success("Izmena je uspešno zabeležena.");
      } catch (status: any) {
        if (status === 403) {
          toast.error("Neočekivana greška");
        } else if (status === 400) {
          toast.error("Neočekivana greška");
        }
      }
    }, 1000),
    [dispatch]
  );

  return (
    <>
      {item.receivedPayments.map((payment, paymentIndex) => (
        <div className="row" key={payment.receivedPaymentId}>
          <div className="col center">
            {hasFullAccessTo(user, PARTNER_MODULE_NAME)
              ?
              <InfoTooltip tooltip="Obriši zapis" classesProp="btn delete-btn" element="span">
                <button
                  className="btn delete-btn"
                  onClick={() => {
                    dispatch(
                      setIndexesForPaymentDeletion({ accountIndex, paymentIndex })
                    );
                  }}
                >
                  <CancelIcon sx={{ color: grey[300] }} fontSize="small" />
                </button>
              </InfoTooltip>
              : <></>}
          </div>
          <div className="col center">
            <div className="bg-item bg-item-border-light center w80">
              <span className="w80">{item.accountReceivable.invoiceId}</span>
            </div>
          </div>
          <div className="col center" />
          <div className="col center">
            <div className="bg-item bg-transparent">
              <DatePicker
                popperProps={{ strategy: "fixed" }}
                className="date-picker bg-item-border-light light bg-transparent"
                showMonthDropdown
                showYearDropdown
                onChange={(date) => {
                  if (date) {
                    onChangeBasicField({
                      receivedPaymentId: payment.receivedPaymentId,
                      accountReceivableId: payment.accountReceivableId,
                      date: FormatDateIso(date)
                    });
                  }
                }}
                selected={payment.date
                  ? new Date(payment.date) : null}
                dateFormat="dd.MM.yy"
                disabled={!hasWriteAccessTo(user, PARTNER_MODULE_NAME)}
              />
            </div>
          </div>
          <div className="col center" />
          <div className="col center" />
          <div className="col center">
            <div className="bg-item bg-transparent right">
              <span className="light">keš&nbsp;</span>
              <input type="checkbox"
                checked={payment.isCash}
                onChange={hasWriteAccessTo(user, PARTNER_MODULE_NAME)
                  ? (e) => {
                    onChangeBasicField({
                      receivedPaymentId: payment.receivedPaymentId,
                      accountReceivableId: payment.accountReceivableId,
                      isCash: e.target.checked
                    });
                  }
                  : undefined}
                disabled={!hasWriteAccessTo(user, PARTNER_MODULE_NAME)}
              />
            </div>
          </div>
          <div className="col center">
            <NumberInput
              formatAs="quantity"
              onChange={(value: string, unmaskedValue: string, parsedValue: number) => {
                if (parsedValue !== payment.amount) {
                  onChangeBasicField({
                    receivedPaymentId: payment.receivedPaymentId,
                    accountReceivableId: payment.accountReceivableId,
                    amount: parsedValue
                  });
                }
              }}
              value={`${payment.amount}`}
              className="bg-item bg-item-border-light light center bg-transparent"
              disabled={!hasWriteAccessTo(user, PARTNER_MODULE_NAME)}
            />
          </div>
          <div className="col center" />
          <div className="col center">
            <div className="bg-item bg-item-border-light center">
              <span className="light">{getVatRatePresentation(item.accountReceivable.vatRate)}</span>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};
